<template>
  <a @click="showInspirations">
    <div class="box flex">
      <div class="grow font-medium">
        {{ $truncate(inspiration_list.attributes.name, 50) }}
      </div>
      <div class="italic">
        {{ inspiration_list.attributes.inspirations_count }}
        <FontAwesomeIcon icon="images" />
      </div>
    </div>
  </a>
</template>

<script>
export default {
  name: 'InspirationList',
  props: {
    inspiration_list: {
      type: Object,
      required: true,
    },
  },

  methods: {
    showInspirations() {
      this.$emit('select', this.inspiration_list.id);
    },
  },
};
</script>
